import { render, staticRenderFns } from "./addNote.vue?vue&type=template&id=5f5ac149&lang=pug"
import script from "./addNote.vue?vue&type=script&lang=js"
export * from "./addNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports